var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke-width:1.5px;}.a,.b{stroke:#353841;}.b,.d{fill:none;}.b{stroke-linecap:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49 -541)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(49 541)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 16,
    height: 19,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 17.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.169,13700.432h3.979",
    transform: "translate(-15109 -13156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.168,13700.432h9.52",
    transform: "translate(-15108.999 -13153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.168,13700.432h9.52",
    transform: "translate(-15108.999 -13149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.168,13700.432h9.52",
    transform: "translate(-15108.999 -13147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.168,13700.432h3.48",
    transform: "translate(-15102.96 -13145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.168,13700.432h9.52",
    transform: "translate(-15108.999 -13151)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.97656df02c1a649ef8e347b65ee9a3aa.svg";
export { ForwardRef as ReactComponent };